import { Cookies } from 'react-cookie';

import { AdminDeviceIntakeResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getAdminDeviceIntake = async (search = '') => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.get<AdminDeviceIntakeResponse>('v1/admin/device-intake', {
    headers: {
      Authorization: token,
    },
    params: { search },
  });

  return response.data;
};
